export const CALL_SERVER_REQUEST = 'call_server_request'
export const CALL_SERVER_RESPONSE = 'call_server_response'
export const CALL_SERVER_ERROR = 'call_server_error'
